import {apiSlice} from './apiSlice';

/**
 * Endpoints module AI SEO (#4).
 *
 * - getAiStatus : provider hiện tại + đã cấu hình khoá chưa (FE hiện cảnh báo).
 * - getAiTasks  : danh sách tác vụ (label/description/inputs) để dựng form động.
 * - generateAi  : chạy 1 tác vụ ({task, input, project_id}) → trả kết quả + lưu lịch sử.
 * - getAiHistory / getAiHistoryDetail : lịch sử + chi tiết 1 bản ghi.
 * - deleteAiHistory : xoá 1 bản ghi lịch sử.
 */
export const aiApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getAiStatus: builder.query({
			query: () => ({url: 'ai/status', method: 'get'}),
			transformResponse: (body) => body?.data || null,
		}),
		getAiTasks: builder.query({
			query: () => ({url: 'ai/tasks', method: 'get'}),
			transformResponse: (body) => body?.data || [],
		}),
		generateAi: builder.mutation({
			query: (payload) => ({url: 'ai/generate', method: 'post', data: payload}),
			transformResponse: (body) => body?.data || null,
			// 'Subscription' → sidebar token còn lại tự cập nhật sau khi tốn token.
			invalidatesTags: ['AiHistory', 'Subscription'],
		}),
		getAiHistory: builder.query({
			query: (params = {}) => ({url: 'ai/history', method: 'get', params}),
			transformResponse: (body) => body?.data || [],
			providesTags: ['AiHistory'],
		}),
		getAiHistoryDetail: builder.query({
			query: (id) => ({url: `ai/history/${id}`, method: 'get'}),
			transformResponse: (body) => body?.data || null,
			providesTags: (result, error, id) => [{type: 'AiHistory', id}],
		}),
		deleteAiHistory: builder.mutation({
			query: (id) => ({url: `ai/history/${id}`, method: 'delete'}),
			invalidatesTags: ['AiHistory'],
		}),

		/* ---- AI SEO Assistant (#30) — chatbot trong dự án ---- */
		getAssistantContext: builder.query({
			query: (projectId) => ({url: `ai/projects/${projectId}/assistant/context`, method: 'get'}),
			transformResponse: (body) => body?.data || null,
		}),
		getConversations: builder.query({
			query: (projectId) => ({url: `ai/projects/${projectId}/assistant/conversations`, method: 'get'}),
			transformResponse: (body) => body?.data || [],
			providesTags: ['AiConversation'],
		}),
		getConversationMessages: builder.query({
			query: (id) => ({url: `ai/conversations/${id}`, method: 'get'}),
			transformResponse: (body) => body?.data || null,
			providesTags: (result, error, id) => [{type: 'AiConversation', id}],
		}),
		sendAssistantChat: builder.mutation({
			query: ({projectId, message, conversation_id}) => ({
				url: `ai/projects/${projectId}/assistant/chat`,
				method: 'post',
				data: {message, conversation_id: conversation_id || 0},
			}),
			transformResponse: (body) => body?.data || null,
			// 'Subscription' → sidebar token còn lại tự cập nhật sau khi tốn token.
			invalidatesTags: ['AiConversation', 'Subscription'],
		}),
		deleteConversation: builder.mutation({
			query: (id) => ({url: `ai/conversations/${id}`, method: 'delete'}),
			invalidatesTags: ['AiConversation'],
		}),
	}),
});

export const {
	useGetAiStatusQuery,
	useGetAiTasksQuery,
	useGenerateAiMutation,
	useGetAiHistoryQuery,
	useGetAiHistoryDetailQuery,
	useDeleteAiHistoryMutation,
	useGetAssistantContextQuery,
	useGetConversationsQuery,
	useGetConversationMessagesQuery,
	useSendAssistantChatMutation,
	useDeleteConversationMutation,
} = aiApiSlice;
